import React, { useState, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Table,
  Row,
  Col,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
// import WhatsAppAPI from "../../api/WhatsAppAPI";
import { faL } from "@fortawesome/free-solid-svg-icons";
import jwt_decode from "jwt-decode";
// import CountryCode from "../../constants/CountryCode.json";
import CountryCode from '../../../constants/CountryCode.json'
import { CFormCheck, CListGroup, CListGroupItem } from "@coreui/react";
import SparkApi from "../../../api/SparkApi";

const CreateCompany = () => {
  const [userInfo, setUserInfo] = useState(
    jwt_decode(localStorage.getItem("token"))
  );
  console.log("=>>>>>>>>>>>>>>>>>>>>>>>>", localStorage.getItem("token"));
  const location = useLocation();
  const initialData = location.state;
  const navigate = useNavigate();
  const isEditMode = !!initialData?.id;
  const [formNumber, setFormNumber] = useState(0);
  console.log('userInfouserInfo@@@', userInfo);
  const [formData, setFormData] = useState({
    schema: {
      source_schemaname: "",
      target_schemaname: "",
    },
    company_info: {
      name: "",
      tenantcode: "",
      isactive: false,
      systememail: userInfo.email,
      adminemail: "",
      logourl: "",
      street: "",
      city: "",
      state: "",
      pincode: "",
      country: "India",
    },
    user_info: {
      firstname: "",
      lastname: "",
      password: "",
      email: "",
      whatsapp_number: "",
      country_code: "",
    },
    invoice: {
      plan: "",
      planname: "",
      amount: "",
      validity: "",
      date: "",
      plan_amount: "",
      addon_amount: "",
      total_amount: "",
    },
    addons: [],
  });
  console.log("userInfouserInfo", userInfo);
  const [availablePlans, setAvailablePlans] = useState([]);
  const [availableSchemas, setAvailableSchemas] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isFreePlan, setIsFreePlan] = useState(false);
  const steps = [
    "Schema Information",
    "Company Information",
    "Company Address",
    "User Information",
    "Subscription Plans",
  ];
  // const [emailError, setEmailError] = useState({ systememail: '', adminemail: '' });
  const [showPassword, setShowPassword] = useState(false);
  // Added by Yamini
  const [availableAddons, setAvailableAddons] = useState([]);
  const [selectedAddonData, setSelectedAddonData] = useState([]);

  useEffect(() => {
    fetchSchemas();
    fetchPlans();
    fetchAddons();
  }, []);

  // New useEffect to fetch company only after availablePlans are loaded
  useEffect(() => {
    console.log("[DEBUG] useEffect: initialData", initialData);
    console.log("[DEBUG] useEffect: availablePlans", availablePlans);
    if (initialData && initialData.id && availablePlans.length > 0) {
      console.log(
        "[DEBUG] useEffect: Calling fetchCompany with id",
        initialData.id
      );
      fetchCompany(initialData.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, availablePlans]);

  const fetchPlans = async () => {
    try {
      const response = await SparkApi.getPlanData("active");
      if (response.success) {
        setAvailablePlans(response.records);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const fetchSchemas = async () => {
    const result = await SparkApi.fetchSourceSchemas();
    console.log("Result->>",result);
    if (result.sourceSchemaResult) {
      setAvailableSchemas(result.sourceSchemaResult);
    } else {
      toast.error("Failed to fetch schemas.");
    }
  };
  // Added By yamini
  const fetchAddons = async () => {
    try {
      const response = await SparkApi.getAllAddons();
      if (response.success) {
        setAvailableAddons(response.records);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const fetchCompany = async (id) => {
    try {
      console.log("[DEBUG] fetchCompany: id", id);
      const response = await SparkApi.findCompanyWithUser(id);
      console.log("[DEBUG] fetchCompany: response", response);
      if (response.companyResult) {
        const companyData = response.companyResult[0];
        console.log("[DEBUG] fetchCompany: companyData", companyData);
        setSelectedAddonData(companyData.addons); //Added By Yamini
        const selected = availablePlans.find(
          (plan) => plan.plan_info.id === companyData.plan_id
        );
        setIsFreePlan(true);
        setSelectedPlan(selected);
        setFormData({
          schema: {
            source_schemaname: companyData.sourceschema,
            target_schemaname: companyData.tenantcode,
          },
          company_info: {
            companyId: companyData.company_id,
            name: companyData.company_name,
            tenantcode: companyData.tenantcode,
            isactive: companyData.isactive,
            systememail: companyData.systememail,
            adminemail: companyData.adminemail,
            logourl: companyData.logourl,
            street: companyData.street,
            city: companyData.city,
            state: companyData.state,
            pincode: companyData.pincode,
            country: companyData.country || "India",
          },
          user_info: {
            userId: companyData.user_id,
            firstname: companyData.firstname,
            lastname: companyData.lastname,
            password: companyData.password,
            email: companyData.email,
            whatsapp_number: companyData.whatsapp_number || "",
            country_code: companyData.country_code || "+91",
          },
          invoice: {
            plan: companyData.plan_id,
            planname: companyData.plan_name,
            amount: companyData.amount,
            validity: companyData.validity,
            date: new Date(companyData.invoice_date)
              .toISOString()
              .split("T")[0],
            subscriptionId: companyData.subscription_id,
            invoiceId: companyData.invoice_id,
          },
          addons: companyData.addons || [],
        });
        // Debug log after setting form data
        setTimeout(() => {
          console.log("[DEBUG] fetchCompany: formData after set", formData);
        }, 0);
      }
    } catch (error) {
      console.error("[DEBUG] fetchCompany: Error fetching company", error);
    }
  };

  const handleChange = (e, section) => {
    const { name, value } = e.target;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value,
        },
      };

      if (section === "schema" && name === "target_schemaname") {
        updatedData.company_info.tenantcode = value;

        // Format the schema name: lowercase, spaces to underscores
        const formattedSchema = value.trim().toLowerCase().replace(/\s+/g, "_");
        const password =
          formattedSchema + "#@" + Math.floor(Math.random() * 1000 + 100);
        updatedData.user_info.password = password;
      }
      if (section === "user_info" && name === "email") {
        updatedData.company_info.adminemail = value;
      }
      console.log("updatedData", updatedData);
      return updatedData;
    });
  };

  const handleFileUpload = (e, section, key) => {
    const file = e.target.files[0];
    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [key]: file,
        },
      }));
    } else {
      toast.error("Only PNG and JPG images are allowed.");
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateStep = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formNumber === 0) {
      const { source_schemaname, target_schemaname } = formData.schema;
      const isTargetSchemaValid = availableSchemas.includes(target_schemaname);
      if (isEditMode) {
        return (
          source_schemaname.trim() !== "" && target_schemaname.trim() !== ""
        );
      }

      return (
        source_schemaname.trim() !== "" &&
        target_schemaname.trim() !== "" &&
        source_schemaname !== target_schemaname &&
        !isTargetSchemaValid
      );
    }
    if (formNumber === 1) {
      const { systememail, logourl } = formData.company_info;

      const isSystemEmailValid = emailRegex.test(systememail);
      const isLogoFileValid =
        (logourl instanceof File && logourl.name.trim() !== "") ||
        (typeof logourl === "string" && logourl.trim() !== "");
      return (
        (formData?.company_info?.name || "").trim() !== "" &&
        (systememail || "").trim() !== "" &&
        isSystemEmailValid &&
        isLogoFileValid
      );
    }

    if (formNumber === 3) {
      return (
        formData.user_info.firstname.trim() !== "" &&
        formData.user_info.lastname.trim() !== "" &&
        emailRegex.test(formData.user_info.email) &&
        formData.user_info.whatsapp_number.trim() !== "" &&
        formData.user_info.password.trim() !== ""
      );
    }
    if (formNumber === 4) {
      const { plan, date, amount } = formData.invoice;

      const isAmountRequired = !isFreePlan;
      return (
        plan.trim() !== "" &&
        date.trim() !== "" &&
        (!isAmountRequired || amount > 0)
      );
    }

    return true;
  };

  const handlePlanChange = (e) => {
    const selectedPlanId = e.target.value;
    const selected = availablePlans.find(
      (plan) => String(plan.plan_info.id) === String(selectedPlanId)
    );

    setSelectedPlan(null);
    setFormData((prev) => ({
      ...prev,
      invoice: {
        ...prev.invoice,
        planname: "",
        plan: "",
        amount: "",
        validity: "",
      },
    }));

    setSelectedPlan(selected);
    console.log("selected", selected);
    if (!selected) return;

    const isFreePlan = selected.plan_info.name.toLowerCase() === "free";

    setFormData((prev) => ({
      ...prev,
      invoice: {
        ...prev.invoice,
        planname: selected.plan_info.name,
        plan: selectedPlanId,
        amount: isFreePlan ? "" : prev.invoice.amount,
        validity: "",
      },
    }));

    setIsFreePlan(isFreePlan);
  };

  const handleAmountTypeChange = (e) => {
    const selectedAmount = Number(e.target.value);
    console.log("selectedAmount", selectedAmount);
    setFormData((prev) => ({
      ...prev,
      invoice: {
        ...prev.invoice,
        // Added by Yamini
        validity:
          selectedAmount === selectedPlan.plan_info.price_per_month
            ? 1
            : selectedAmount === selectedPlan.plan_info.price_per_quarterly
              ? 3
              : selectedAmount === selectedPlan.plan_info.price_per_half_yearly
                ? 6
                : 12,
        amount: selectedAmount,
      },
    }));
  };

  // Added By Yamini
  const handleAddonCheckChange = (e, addon) => {
    const isChecked = e.target.checked;

    const billingPeriod =
      formData.invoice.validity === 1
        ? "monthly"
        : formData.invoice.validity === 3
          ? "quarterly"
          : formData.invoice.validity === 6
            ? "half_yearly"
            : "yearly";

    const unit_price = addon[billingPeriod] || 0;
    const quantity = 1;
    const invoice_amount = unit_price * quantity;

    setFormData((prev) => {
      let updatedAddons = [];

      if (isChecked) {
        updatedAddons = [
          ...prev.addons,
          {
            addon_id: addon.id,
            name: addon.name,
            quantity,
            unit_price,
            invoice_amount,
          },
        ];
      } else {
        updatedAddons = prev.addons.filter((a) => a.addon_id !== addon.id);
      }

      const addon_amount = updatedAddons.reduce(
        (sum, addon) => sum + (addon.invoice_amount || 0),
        0
      );

      const plan_amount = Number(prev.invoice.amount) || 0;
      const total_amount = plan_amount + addon_amount;

      return {
        ...prev,
        addons: updatedAddons,
        invoice: {
          ...prev.invoice,
          plan_amount,
          addon_amount,
          total_amount,
        },
      };
    });
  };

  // Added By Yamini
  const handleAddonQuantityChange = (e, addonId) => {
    const quantity = parseInt(e.target.value) || 1;

    const billingPeriod =
      formData.invoice.validity === 1
        ? "monthly"
        : formData.invoice.validity === 3
          ? "quarterly"
          : formData.invoice.validity === 6
            ? "half_yearly"
            : "yearly";

    setFormData((prev) => {
      const updatedAddons = prev.addons.map((addon) => {
        if (addon.addon_id === addonId) {
          const matchedAddon = availableAddons.find((a) => a.id === addonId);
          const unit_price = matchedAddon
            ? matchedAddon[billingPeriod] || 0
            : 0;
          const invoice_amount = unit_price * quantity;

          return {
            ...addon,
            quantity,
            unit_price,
            invoice_amount,
          };
        }
        return addon;
      });

      const addon_amount = updatedAddons.reduce(
        (sum, addon) => sum + (addon.invoice_amount || 0),
        0
      );
      const plan_amount = Number(prev.invoice.amount) || 0;
      const total_amount = plan_amount + addon_amount;

      return {
        ...prev,
        addons: updatedAddons,
        invoice: {
          ...prev.invoice,
          plan_amount,
          addon_amount,
          total_amount,
        },
      };
    });
  };

  const handleBackClick = () => {
    if (formNumber > 0) {
      setFormNumber(formNumber - 1);
    } else {
      navigate("/company");
    }
  };

  const handleNextClick = async () => {
    if (formNumber === 1) {
      const selected = availablePlans.find(
        (plan) => plan.plan_info.id === formData.invoice.plan
      );
      setSelectedPlan(selected);
    }
    if (formNumber === 3) {
      const { adminemail, companyId } = formData.company_info;
      try {
        const emailCheckResponse = await SparkApi.duplicateEmailCheck(
          adminemail,
          companyId
        );
        if (emailCheckResponse.success) {
          toast.error(
            "This email is already registered. Please use a different email."
          );
          return;
        }
      } catch (error) {
        toast.error("Unable to verify email. Please try again.");
        return;
      }
    }
    if (formNumber < steps.length - 1) {
      setFormNumber(formNumber + 1);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      formData.user_info.country_code = formData.user_info.country_code
        ? String(formData.user_info.country_code).trim()
        : "+91";
      console.log("handleFormSubmit formData", formData);
      const result = formData.company_info.companyId
        ? await SparkApi.updateCompanyWithUser(formData)
        : await SparkApi.createCompany(formData);
      if (result.success) {
        toast.success(
          formData.company_info.companyId
            ? "Record updated successfully."
            : "Record created successfully."
        );
        navigate("/company");
      } else {
        toast.error(result.message || "Failed to save record.");
      }
    } catch (error) {
      console.error("Error during save operation", error);
      toast.error("An unexpected error occurred while saving the record.");
    }
  };

  const getSelectedBillingPeriod = () => {
    const { amount } = formData.invoice;
    const prices = selectedPlan?.plan_info;

    if (!amount || !prices) return "";

    if (amount === prices.price_per_month) return "monthly";
    if (amount === prices.price_per_quarterly) return "quarterly";
    if (amount === prices.price_per_half_yearly) return "half_yearly";
    if (amount === prices.price_per_year) return "yearly";

    return "";
  };

  const billingPeriod = getSelectedBillingPeriod();

  console.log("formData", formData);
  return (
    <>
      <Container className="mt-5">
        <Row className="mx-5 text-center g-0">
          <Col lg={12} sm={12}>
            <div
              className="text-center p-2"
              style={{
                height: "40px",
                backgroundColor: "#ffffff",
                borderRadius: "5px",
              }}
            >
              <span
                className="fw-semibold p-1"
                style={{ color: "#605C68", fontSize: "large" }}
              >
                Add Company
              </span>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="mt-4 mb-5">
        <Row className="mx-5 g-0">
          <Col lg={12} sm={12}>
            <Card>
              <Card.Header>
                <div className="d-flex justify-content-between align-items-center">
                  {steps.map((step, index) => (
                    <div
                      key={index}
                      className={`text-center ${index === formNumber
                        ? "fw-bold text-white"
                        : "text-light"
                        }`}
                      style={{ flex: 1 }}
                    >
                      <div
                        className={`rounded-circle d-inline-flex align-items-center justify-content-center ${index === formNumber
                          ? "bg-white text-primary"
                          : "rgb(125 156 233) text-white"
                          }`}
                        style={{
                          width: 32,
                          height: 32,
                          fontSize: "1rem",
                          marginTop: "0.9rem",
                        }}
                      >
                        {index + 1}
                      </div>
                      <div
                        className="mb-2"
                        style={{ fontSize: "0.9rem", marginTop: "0.2rem" }}
                      >
                        {step}
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Header>
              <Card.Body className="m-5">
                <Row>
                  <Col>
                    {formNumber === 0 && (
                      <Form>
                        <h2 className="mb-3">Your Schema Information</h2>
                        <p className="text-muted mb-4">
                          <em>Enter your Schema information.</em>
                        </p>
                        <Row className="mb-3">
                          <Col lg={12} sm={12} xs={12}>
                            <Form.Group>
                              <Form.Label>Source Schema</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                as="select"
                                name="source_schemaname"
                                value={formData.schema.source_schemaname}
                                onChange={(e) => handleChange(e, "schema")}
                                required
                                disabled={isEditMode}
                              >
                                <option value="">Select Schema</option>
                                {availableSchemas.map((schema) => (
                                  <option key={schema} value={schema}>
                                    {schema}
                                  </option>
                                ))}
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col lg={12} sm={12} xs={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>Target Schema</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Target Schema"
                                name="target_schemaname"
                                value={formData.schema.target_schemaname}
                                onChange={(e) => handleChange(e, "schema")}
                                required
                                disabled={isEditMode}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    )}
                    {formNumber === 1 && (
                      <Form>
                        <h2 className="mb-3">Company Information</h2>
                        <p className="text-muted mb-4">
                          <em>Enter your Company information.</em>
                        </p>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Company Name</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Name"
                                name="name"
                                value={formData.company_info.name}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Tenant Code</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Tenant Code"
                                name="tenantcode"
                                value={formData.company_info.tenantcode}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                                disabled
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Logo URL</Form.Label>
                              <Form.Control
                                type="file"
                                accept=".png, .jpg"
                                onChange={(e) =>
                                  handleFileUpload(e, "company_info", "logourl")
                                }
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>System Email</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="email"
                                placeholder="Enter System Email"
                                name="systememail"
                                value={formData.company_info.systememail}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                                // isInvalid={!!emailError.systememail}
                                disabled
                              />
                              {/* <Form.Control.Feedback type="invalid">
                                    {emailError.systememail}
                                  </Form.Control.Feedback> */}
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Status</Form.Label>
                              <div>
                                <Form.Check
                                  type="checkbox"
                                  id="isactive-checkbox"
                                  label="Active"
                                  name="isactive"
                                  checked={
                                    formData.company_info.isactive === true
                                  }
                                  onChange={(e) =>
                                    handleChange(
                                      {
                                        target: {
                                          name: "isactive",
                                          value: e.target.checked,
                                        },
                                      },
                                      "company_info"
                                    )
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    )}
                    {formNumber === 2 && (
                      <Form>
                        <h2 className="mb-3">Company Address</h2>
                        <p className="text-muted mb-4">
                          <em>Enter your Company Address.</em>
                        </p>
                        <Row className="mb-3">
                          <Col md={12}>
                            <Form.Group>
                              <Form.Label>Street</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Street"
                                name="street"
                                value={formData.company_info.street}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>City</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter City"
                                name="city"
                                value={formData.company_info.city}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>State</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter State"
                                name="state"
                                value={formData.company_info.state}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Country</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Country"
                                name="country"
                                value={formData.company_info.country}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Pin Code</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Pin Code"
                                name="pincode"
                                value={formData.company_info.pincode}
                                onChange={(e) =>
                                  handleChange(e, "company_info")
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    )}
                    {formNumber === 3 && (
                      <Form>
                        <h2 className="mb-3">User Information</h2>
                        <p className="text-muted mb-4">
                          <em>Enter your User Information.</em>
                        </p>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>First Name</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter First Name"
                                name="firstname"
                                value={formData.user_info.firstname}
                                onChange={(e) => handleChange(e, "user_info")}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Last Name</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Last Name"
                                name="lastname"
                                value={formData.user_info.lastname}
                                onChange={(e) => handleChange(e, "user_info")}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Email</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="email"
                                placeholder="Enter Email"
                                name="email"
                                value={formData.user_info.email}
                                onChange={(e) => handleChange(e, "user_info")}
                                required
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group>
                              <Form.Label>Country Code</Form.Label>
                              <Form.Select
                                style={{ height: "36px" }}
                                required
                                name="country_code"
                                value={formData.user_info.country_code || "+91"}
                                onChange={(e) => handleChange(e, "user_info")}
                              >
                                {CountryCode.map((country, index) => (
                                  <option
                                    key={index}
                                    value={country.country_code}
                                  >
                                    {country.country} ({country.country_code})
                                  </option>
                                ))}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group>
                              <Form.Label>Phone Number</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="text"
                                placeholder="Enter Phone Number"
                                name="whatsapp_number"
                                value={formData.user_info.whatsapp_number}
                                onChange={(e) => handleChange(e, "user_info")}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        {!("userId" in formData.user_info) && (
                          <Row className="mb-3">
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>Password</Form.Label>
                                <div style={{ position: "relative" }}>
                                  <Form.Control
                                    style={{
                                      height: "36px",
                                      paddingRight: "40px",
                                    }}
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter Password"
                                    name="password"
                                    value={formData.user_info.password}
                                    onChange={(e) =>
                                      handleChange(e, "user_info")
                                    }
                                    required
                                  />
                                  <i
                                    className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"
                                      }`}
                                    onClick={togglePasswordVisibility}
                                    style={{
                                      position: "absolute",
                                      right: "10px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      color: "#6c757d",
                                    }}
                                  ></i>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        )}
                      </Form>
                    )}

                    {formNumber === 4 && (
                      <Form>
                        <h2 className="mb-3">Plan</h2>
                        <p className="text-muted mb-4">
                          <em>Select Plan.</em>
                        </p>
                        <Row className="mb-3">
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Subscription Plan</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                as="select"
                                name="plan"
                                value={formData.invoice.plan}
                                onChange={handlePlanChange}
                              >
                                <option value="">Select Plan</option>
                                {availablePlans.map((plan) => (
                                  <option
                                    key={plan.plan_info.id}
                                    value={plan.plan_info.id}
                                  >
                                    {plan.plan_info.name}
                                  </option>
                                ))}
                              </Form.Control>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group>
                              <Form.Label>Date</Form.Label>
                              <Form.Control
                                style={{ height: "36px" }}
                                type="date"
                                name="date"
                                value={formData.invoice.date}
                                onChange={(e) => handleChange(e, "invoice")}
                                required
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        {selectedPlan && (
                          <>
                            <Row>
                              <Col md={6}>
                                <Form.Group>
                                  <strong>Number of Users</strong> :{" "}
                                  {selectedPlan.plan_info.number_of_users || 0}{" "}
                                  <br />
                                  <strong>
                                    Number of WhatsApp Settings
                                  </strong> :{" "}
                                  {selectedPlan.plan_info
                                    .number_of_whatsapp_setting || 0}
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                {selectedPlan.plan_info.price_per_month > 0 ||
                                  selectedPlan.plan_info.price_per_quarterly >
                                  0 ||
                                  selectedPlan.plan_info.price_per_half_yearly >
                                  0 ||
                                  selectedPlan.plan_info.price_per_year > 0 ? (
                                  <Form.Group>
                                    <Form.Label>Amount</Form.Label>
                                    <div className="d-flex align-items-center">
                                      {selectedPlan.plan_info.price_per_month >
                                        0 && (
                                          <Form.Check
                                            type="radio"
                                            name="amount"
                                            value={
                                              selectedPlan.plan_info
                                                .price_per_month
                                            }
                                            label={`Monthly: ₹ ${selectedPlan.plan_info.price_per_month}`}
                                            checked={
                                              formData.invoice.validity === 1
                                            }
                                            // checked={
                                            //   formData.invoice.amount ===
                                            //   selectedPlan.plan_info
                                            //     .price_per_month
                                            // }
                                            onChange={handleAmountTypeChange}
                                            className="me-3"
                                          />
                                        )}
                                      {console.log(
                                        "formData.invoice",
                                        formData.invoice
                                      )}
                                      {console.log(
                                        "formData.invoice selectedPlan.plan_info",
                                        selectedPlan.plan_info
                                      )}
                                      {/* // Added by Yamini */}
                                      {selectedPlan.plan_info
                                        .price_per_quarterly > 0 && (
                                          <Form.Check
                                            type="radio"
                                            name="amount"
                                            value={
                                              selectedPlan.plan_info
                                                .price_per_quarterly
                                            }
                                            label={`Quarterly: ₹ ${selectedPlan.plan_info.price_per_quarterly}`}
                                            checked={
                                              formData.invoice.validity === 3
                                            }
                                            onChange={handleAmountTypeChange}
                                            className="me-3"
                                          />
                                        )}
                                      {/* // Added by Yamini */}
                                      {selectedPlan.plan_info
                                        .price_per_half_yearly > 0 && (
                                          <Form.Check
                                            type="radio"
                                            name="amount"
                                            value={
                                              selectedPlan.plan_info
                                                .price_per_half_yearly
                                            }
                                            label={`Half Yearly: ₹ ${selectedPlan.plan_info.price_per_half_yearly}`}
                                            checked={
                                              formData.invoice.validity === 6
                                            }
                                            // checked={
                                            //   formData.invoice.amount ===
                                            //   selectedPlan.plan_info
                                            //     .price_per_half_yearly
                                            // }
                                            onChange={handleAmountTypeChange}
                                            className="me-3"
                                          />
                                        )}
                                      {selectedPlan.plan_info.price_per_year >
                                        0 && (
                                          <Form.Check
                                            type="radio"
                                            name="amount"
                                            value={
                                              selectedPlan.plan_info
                                                .price_per_year
                                            }
                                            label={`Yearly: ₹ ${selectedPlan.plan_info.price_per_year}`}
                                            checked={
                                              formData.invoice.validity === 12
                                            }
                                            // checked={
                                            //   formData.invoice.amount ===
                                            //   selectedPlan.plan_info
                                            //     .price_per_year
                                            // }
                                            onChange={handleAmountTypeChange}
                                          />
                                        )}
                                    </div>
                                  </Form.Group>
                                ) : (
                                  ""
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <div className="mt-3">
                                  <strong className="mt-4 mb-2">Modules</strong>
                                  <Row className="mt-2">
                                    {selectedPlan.plan_modules.map(
                                      (module, index) => {
                                        return (
                                          <Col md={6} key={module.id}>
                                            <i className="fa fa-tasks mx-2"></i>
                                            {module.name}
                                          </Col>
                                        );
                                      }
                                    )}
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                            {formData.invoice.amount && (
                              <Row className="mb-3 mt-4">
                                <Form.Label className="mb-2">
                                  <strong className="mt-4 mb-2">
                                    Addon Plans
                                  </strong>
                                </Form.Label>
                                <div
                                  style={{
                                    maxHeight: "130px",
                                    overflowY: "auto",
                                  }}
                                >
                                  <CListGroup>
                                    {availableAddons?.map((addon) => {
                                      const selectedAddon =
                                        formData.addons.find(
                                          (a) => a.addon_id === addon.id
                                        );
                                      const isChecked = !!selectedAddon;
                                      const quantityValue =
                                        selectedAddon?.quantity || 1;

                                      return (
                                        <CListGroupItem
                                          key={addon.id}
                                          className="d-flex align-items-center justify-content-between"
                                        >
                                          <div className="d-flex align-items-center">
                                            <CFormCheck
                                              id={`addon-${addon.id}`}
                                              // label={<strong className="mt-4 mb-2">{addon.name}</strong>}
                                              label={addon.name}
                                              checked={isChecked}
                                              onChange={(e) =>
                                                handleAddonCheckChange(e, addon)
                                              }
                                            />
                                          </div>

                                          <div className="d-flex align-items-center">
                                            <label
                                              htmlFor={`qty-${addon.id}`}
                                              className="me-2 mb-0"
                                            >
                                              {/* <strong className="mt-4 mb-2"> */}
                                              Quantity:
                                              {/* </strong> */}
                                            </label>
                                            <input
                                              id={`qty-${addon.id}`}
                                              type="number"
                                              min="1"
                                              value={quantityValue}
                                              className="form-control form-control-sm w-auto"
                                              onChange={(e) =>
                                                handleAddonQuantityChange(
                                                  e,
                                                  addon.id
                                                )
                                              }
                                              disabled={!isChecked}
                                            />
                                          </div>
                                        </CListGroupItem>
                                      );
                                    })}
                                  </CListGroup>
                                </div>

                                {/* {availableAddons?.map((addon) => {
                                  const selectedAddon = formData.addons.find(
                                    (a) => a.addon_id === addon.id
                                  );
                                  const isChecked = !!selectedAddon;
                                  const quantityValue =
                                    selectedAddon?.quantity || 1;
                                  console.log("addon", addon);
                                  return (
                                    <Col
                                      md={6}
                                      key={addon.id}
                                      className="d-flex align-items-center mb-3"
                                    >
                                      <Form.Check
                                        type="checkbox"
                                        label={addon.name}
                                        // label={`${addon.name} (${addon[billingPeriod] ? `₹ ${addon[billingPeriod]}` : 'N/A'})`}
                                        className="me-2"
                                        checked={isChecked}
                                        onChange={(e) =>
                                          handleAddonCheckChange(e, addon)
                                        }
                                      />
                                      <Form.Label className="ms-2 me-1 mb-0">
                                        Qty:
                                      </Form.Label>
                                      <Form.Control
                                        type="number"
                                        min="1"
                                        value={quantityValue}
                                        className="w-auto"
                                        onChange={(e) =>
                                          handleAddonQuantityChange(e, addon.id)
                                        }
                                        disabled={!isChecked}
                                      />
                                    </Col>
                                  );
                                })} */}
                              </Row>
                            )}
                          </>
                        )}
                      </Form>
                    )}

                    <div className="text-end">
                      <Button
                        variant="light"
                        onClick={handleBackClick}
                        className="me-3"
                      >
                        Back
                      </Button>
                      {formNumber === steps.length - 1 ? (
                        <Button
                          variant="primary"
                          onClick={handleFormSubmit}
                          disabled={!validateStep()}
                        >
                          Submit
                        </Button>
                      ) : (
                        <Button
                          variant="primary"
                          onClick={handleNextClick}
                          disabled={!validateStep()}
                        >
                          Next Step
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
};

export default CreateCompany;
